import { useCallback, useEffect, useMemo, useState } from 'react';
import { employerAPI } from 'utils/api';

export const useEmployerApplications = () => {
  const [applications, setApplications] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadApplications = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await employerAPI.getApplications();
      const data = response?.data || response || [];

      // Deduplicate by vdrId in case backend returns overlaps
      const deduped = [];
      const seen = new Set();
      if (Array.isArray(data)) {
        data.forEach(item => {
          const key = item?.vdrId || item?.applicationId || item?.application_id || item?.id;
          if (!seen.has(key)) {
            seen.add(key);
            deduped.push(item);
          }
        });
      }

      setApplications(deduped);

      const summary = response?.meta?.categories || [];
      setCategories(summary);
    } catch (err) {
      console.error('Failed to load employer applications', err);
      setError(err.response?.data?.error || err.message || 'Failed to load applications');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadApplications();
  }, [loadApplications]);

  const selectableApplications = useMemo(
    () => applications.filter(app => app.isSelectable),
    [applications]
  );

  return {
    applications,
    categories,
    selectableApplications,
    loading,
    error,
    refresh: loadApplications
  };
};
